import React, { useEffect, useRef, useState } from "react";
import "./blog-preview.css";
import { Link } from "react-router-dom";
import { convertDateFormat, getBlogTeaser } from "../Transformations/NewsList";

export default function BlogPreview() {
	const [blogTeasers, setBlogTeasers] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getBlogTeaser();
			setBlogTeasers(data);
		};
		fetchData();
	}, []);

	return (
		<>
			<div className="main-fields blogs-section">
				<div className="field-hd">
					<h2>Blog</h2>
				</div>
				<div className="popout-container">
					{blogTeasers
						? blogTeasers.map((blog, index) => (
								<div className="blog-preview popout-content" key={index}>
									<div className="blog-img">
										<img
											src={blog.blog_image}
											alt="blogImage"
											className="blog-img"
										/>
									</div>

									<a href={"./unternehmen/blog/" + blog.id}>
										<div className="blog-teaser">
											<small className="date">
												{convertDateFormat(blog.blog_date)}
											</small>
											<div className="blog-head">{blog.blog_hd}</div>
											<div className="blog-body font-text">
												{blog.blog_teaser}
											</div>
										</div>
									</a>
								</div>
						  ))
						: ""}
				</div>
			</div>
			<hr></hr>
		</>
	);
}
